import { Context, useContext } from 'react'

export function useOptionalContext<T> (context: Context<T>): Partial<T> {
  return useContext(context)
}
